module.exports = __webpack_public_path__ + "static/media/Report.e122c333.pdf";